import pluralize from "../../utils/pluralize";
import { helpArticles } from "../../utils/helpArticles";
import { PracticeManagement } from "../../types/api.model";
export const getPMDetails = pm => ({
  name: {
    [PracticeManagement.Keeper]: 'Double',
    [PracticeManagement.Karbon]: 'Karbon',
    [PracticeManagement.ClientHub]: 'Client Hub',
    [PracticeManagement.FinancialCents]: 'Financial Cents'
  }[pm],
  item: {
    [PracticeManagement.Keeper]: keeperItem,
    [PracticeManagement.Karbon]: karbonItem,
    [PracticeManagement.ClientHub]: clientHubItem,
    [PracticeManagement.FinancialCents]: financialCentsItem
  }[pm],
  items: {
    [PracticeManagement.Keeper]: pluralize(keeperItem),
    [PracticeManagement.Karbon]: pluralize(karbonItem),
    [PracticeManagement.ClientHub]: pluralize(clientHubItem),
    [PracticeManagement.FinancialCents]: pluralize(financialCentsItem)
  }[pm],
  company: {
    [PracticeManagement.Keeper]: 'client',
    [PracticeManagement.Karbon]: 'organization',
    [PracticeManagement.ClientHub]: 'organization',
    [PracticeManagement.FinancialCents]: 'client'
  }[pm],
  contact: {
    [PracticeManagement.Keeper]: 'contact',
    [PracticeManagement.Karbon]: 'contact',
    [PracticeManagement.ClientHub]: 'client',
    [PracticeManagement.FinancialCents]: 'contact'
  }[pm],
  template: {
    [PracticeManagement.Keeper]: 'task template',
    [PracticeManagement.Karbon]: 'work template',
    [PracticeManagement.ClientHub]: 'job template',
    [PracticeManagement.FinancialCents]: 'template'
  }[pm],
  articleLink: {
    [PracticeManagement.Keeper]: helpArticles.keeper(),
    [PracticeManagement.Karbon]: helpArticles.karbon(),
    [PracticeManagement.ClientHub]: helpArticles.clientHub(),
    [PracticeManagement.FinancialCents]: helpArticles.financialCents()
  }[pm],
  testIdPrefix: {
    [PracticeManagement.Keeper]: 'keeper',
    [PracticeManagement.Karbon]: 'karbon',
    [PracticeManagement.ClientHub]: 'client-hub',
    [PracticeManagement.FinancialCents]: 'financial-cents'
  }[pm]
});
const keeperItem = 'task';
const karbonItem = 'work item';
const clientHubItem = 'job';
const financialCentsItem = 'project';